import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.68421 3.63636H12.3158L18 9.09091V18.1818C18 19.1818 17.1473 20 16.1053 20H5.67473C4.63265 20 3.78947 19.1818 3.78947 18.1818L3.79896 5.45455C3.79896 4.45454 4.64213 3.63636 5.68421 3.63636ZM5.68421 5.45455V18.1818H16.1053V10H11.3684V5.45455H5.68421Z",
		fill: "#00A4EC"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0 12.7273C0 13.3333 0.378947 14.5455 1.89474 14.5455V1.81818H12.3158V0H1.89474C1.26316 0 0 0.363636 0 1.81818V12.7273Z",
		fill: "#00A4EC"
	})]
});
export default SvgFileCopy;
